const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  config: {},
  visibleSections:[],
  // visibleSections: ['home', 'aboutUs', 'contactUs', 'explore'],
  loading: true,
  error: true,
  home:null,
  about:null,
  contact:null
};

const configSlice = createSlice({
  name: "configSlice",
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      state.config = action.payload.data;
      state.loading = false;
      state.error = false;
    },
    saveLandingConfig: (state, action) => {
      state.visibleSections = action.payload.visibleSections;
      state.home = action.payload.home;
      state.about = action.payload.about;
      state.contact = action.payload.contact;
    },
    removeConfig: (state, action) => {
      state.config = {};
      state.loading = true;
      state.error = true;
    },
  },
});

export const { saveConfig, removeConfig, saveLandingConfig } = configSlice.actions;
export default configSlice.reducer;
